import React from 'react';
import Select from 'common/Select';
import { intlShape } from 'common/injectIntl';
import findIndex from 'lodash/findIndex';
import { dateFormat } from 'lib/format';
import DateSlider from './DateSlider';
import StatusFilter from './StatusFilter';

const FilterGroup = ({
    location,
    categories,
    channels,
    onDateSelectorChange,
    onReplayDateSelectorChange,
    onStatusFilterChange,
    onSportsFilterChange,
    onNetworkFilterChange,
    messages,
    intl: { formatMessage }
}) => {
    const query = location.query;
    const statusDefaultSelection = query.type || 'live';
    const sportOptions = [{ label: formatMessage(messages['schedule.allSports']), value: -1, type: 'category' }]
        .concat(categories.map((cat) => ({ label: cat.name, value: cat.id, type: cat.type })));
    const networkOptions = [{ label: formatMessage(messages['schedule.allNetworks']), value: '' }]
        .concat(
            channels.map((channel) => ({
                label: channel.name,
                value: channel.abbreviation,
                type: channel.type
            }))
            .filter((channel) => statusDefaultSelection !== 'replay' || channel.type === 'online')
        );
    const sportDefaultSelection = findIndex(sportOptions, (option) => (option.value.toString() === query.categoryId));
    const networkDefaultSelection = findIndex(networkOptions, (option) => (option.value === query.channel));
    const startDate = dateFormat.paramToDate(query.startDate) || new Date();
    const replayDateSelectorOptions = [
        { label: formatMessage(messages['schedule.replay.all']), value: 'all' },
        { label: formatMessage(messages['schedule.replay.today']), value: 'today' },
        { label: formatMessage(messages['schedule.replay.last7Days']), value: 'last7Days' },
        { label: formatMessage(messages['schedule.replay.last14Days']), value: 'last2Weeks' },
        { label: formatMessage(messages['schedule.replay.last30Days']), value: 'last30Days' }
    ];

    const dateSelector = statusDefaultSelection === 'upcoming' ?
        <DateSlider date={startDate} onDateSelected={onDateSelectorChange} /> : null;
    const replayDateSelector = statusDefaultSelection === 'replay' ?
        <Select options={replayDateSelectorOptions} defaultSelection={2} onChange={onReplayDateSelectorChange} /> : null;

    return (
        <div className="filter-group-wrap">
            <StatusFilter
                selected={statusDefaultSelection}
                handleClick={onStatusFilterChange}
                labels={{
                    [StatusFilter.Options.LIVE]: formatMessage(messages['schedule.live']),
                    [StatusFilter.Options.UPCOMING]: formatMessage(messages['schedule.upcoming']),
                    [StatusFilter.Options.REPLAY]: formatMessage(messages['schedule.replay'])
                }}
            />

            <div className="filters">
                <Select defaultSelection={sportDefaultSelection} options={sportOptions} onChange={onSportsFilterChange} />
                <Select
                    defaultSelection={networkDefaultSelection}
                    options={networkOptions}
                    onChange={onNetworkFilterChange}
                />
            </div>
            <div className="replaydate-wrap">
                {replayDateSelector}
            </div>
            <div className="datepicker-wrap">
                {dateSelector}
            </div>
        </div>
    );
};

FilterGroup.propTypes = {
    categories: React.PropTypes.array,
    channels: React.PropTypes.array,
    onSportsFilterChange: React.PropTypes.func,
    onNetworkFilterChange: React.PropTypes.func,
    onDateSelectorChange: React.PropTypes.func,
    onReplayDateSelectorChange: React.PropTypes.func,
    onStatusFilterChange: React.PropTypes.func,
    location: React.PropTypes.object,
    intl: intlShape.isRequired,
    messages: React.PropTypes.object.isRequired
};

export default FilterGroup;



// WEBPACK FOOTER //
// ./app/schedule/FilterGroup.js